import React, { useState, useEffect } from 'react'
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import uploadImage from '../helpers/uploadImage';
import DisplayImage from './DisplayImage';
import { MdDelete } from "react-icons/md";
import SummaryApi from '../common';
import {toast} from 'react-toastify'

const AdminEditProduct = ({
    onClose,
    productData,
    fetchdata
  }) => {

  const [data,setData] = useState({
    ...productData,
    productName : productData?.productName,
    brandName : productData?.brandName,
    category : productData?.category,
    subcategory : productData?.subcategory,
    productImage : productData?.productImage || [],
    description : productData?.description,
    sellingPrice : productData?.sellingPrice,
    measurement : productData?.measurement,
    size : productData?.size,
    moq : productData?.moq,
    country : productData?.country,
    youtubelink : productData?.youtubelink,
    shipping : productData?.shipping,
    color : productData?.color,   

  })

  const [allCategories, setAllCategories] = useState([]);

  // Function to fetch all categories
  const fetchAllCategories = async () => {
    try {
      const response = await fetch(SummaryApi.getCategories.url);
      const dataResponse = await response.json();

      console.log("Fetched Categories:", dataResponse);

      setAllCategories(dataResponse?.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchAllCategories();
  }, []);


  const [openFullScreenImage,setOpenFullScreenImage] = useState(false)
  const [fullScreenImage,setFullScreenImage] = useState("")


  const handleOnChange = (e)=>{
      const { name, value} = e.target

      setData((preve)=>{
        return{
          ...preve,
          [name]  : value
        }
      })
  }

  const handleUploadProduct = async(e) => {
    const file = e.target.files[0]
    const uploadImageCloudinary = await uploadImage(file)

    setData((preve)=>{
      return{
        ...preve,
        productImage : [ ...preve.productImage, uploadImageCloudinary.url]
      }
    })
  }

  const handleDeleteProductImage = async(index)=>{
    console.log("image index",index)
    
    const newProductImage = [...data.productImage]
    newProductImage.splice(index,1)

    setData((preve)=>{
      return{
        ...preve,
        productImage : [...newProductImage]
      }
    })
    
  }


  {/**upload product */}
  const handleSubmit = async(e) =>{
    e.preventDefault()
    
    const response = await fetch(SummaryApi.updateProduct.url,{
      method : SummaryApi.updateProduct.method,
      credentials : 'include',
      headers : {
        "content-type" : "application/json"
      },
      body : JSON.stringify(data)
    })

    const responseData = await response.json()

    if(responseData.success){
        toast.success(responseData?.message)
        onClose()
        fetchdata()
    }


    if(responseData.error){
      toast.error(responseData?.message)
    }
  

  }

  return (
    <div className='fixed w-full  h-full bg-slate-200 bg-opacity-35 top-0 left-0 right-0 bottom-0 flex justify-center items-center'>
    <div className='bg-white p-4 rounded w-full max-w-2xl h-full max-h-[80%] overflow-hidden'>

         <div className='flex justify-between items-center pb-3'>
             <h2 className='font-bold text-lg'>Edit Product</h2>
             <div className='w-fit ml-auto text-2xl hover:text-red-600 cursor-pointer' onClick={onClose}>
                 <CgClose/>
             </div>
         </div>

       <form className='grid p-4 gap-2 overflow-y-scroll h-full pb-5' onSubmit={handleSubmit}>
         <label htmlFor='productName'>Product Name :</label>
         <input 
           type='text' 
           id='productName' 
           placeholder='enter product name' 
           name='productName'
           value={data.productName} 
           onChange={handleOnChange}
           className='p-2 bg-slate-100 border rounded'
           required
         />

<label htmlFor='country'>Country of Origin :</label>
         <input 
           type='text' 
           id='country' 
           placeholder='enter the country of origin' 
           name='country'
           value={data.productName} 
           onChange={handleOnChange}
           className='p-2 bg-slate-100 border rounded'
           required
         />


         <label htmlFor='brandName' className='mt-3'>Brand Name :</label>
         <input 
           type='text' 
           id='brandName' 
           placeholder='enter brand name' 
           value={data.brandName} 
           name='brandName'
           onChange={handleOnChange}
           className='p-2 bg-slate-100 border rounded'
           required
         />

           <label htmlFor='category' className='mt-3'>Category :</label>
           <select required value={data.category} name='category' onChange={handleOnChange} className='p-2 bg-slate-100 border rounded'>
               <option value={""}>Select Category</option>
               {
                 allCategories?.map((el,index)=>{
                   return(
                     <option value={el.categoryName} key={el._id}>{el.categoryName}</option>
                   )
                 })
               }
           </select>




           <label htmlFor='subcategory' className='mt-3'>Sub Category :</label>
          <select  
  value={data.subcategory} 
  name='subcategory' 
  onChange={handleOnChange} 
  className='p-2 bg-slate-100 border rounded'
>
  <option value={""}>Select Sub Category</option>
  {
    allCategories
      .find((cat) => cat.categoryName === data.category) // ✅ Find selected category
      ?.subCategories.map((sub, index) => ( // ✅ Get its subcategories
        <option value={sub} key={index}>{sub}</option>
      ))
  }
</select>


           <label htmlFor='productImage' className='mt-3'>Product Image :</label>
           <label htmlFor='uploadImageInput'>
           <div className='p-2 bg-slate-100 border rounded h-32 w-full flex justify-center items-center cursor-pointer'>
                     <div className='text-slate-500 flex justify-center items-center flex-col gap-2'>
                       <span className='text-4xl'><FaCloudUploadAlt/></span>
                       <p className='text-sm'>Upload Product Image</p>
                       <input type='file' id='uploadImageInput'  className='hidden' onChange={handleUploadProduct}/>
                     </div>
           </div>
           </label> 
           <div>
               {
                 data?.productImage[0] ? (
                     <div className='flex items-center gap-2'>
                         {
                           data.productImage.map((el,index)=>{
                             return(
                               <div className='relative group'>
                                   <img 
                                     src={el} 
                                     alt={el} 
                                     width={80} 
                                     height={80}  
                                     className='bg-slate-100 border cursor-pointer'  
                                     onClick={()=>{
                                       setOpenFullScreenImage(true)
                                       setFullScreenImage(el)
                                     }}/>

                                     <div className='absolute bottom-0 right-0 p-1 text-white bg-red-600 rounded-full hidden group-hover:block cursor-pointer' onClick={()=>handleDeleteProductImage(index)}>
                                       <MdDelete/>  
                                     </div>
                               </div>
                               
                             )
                           })
                         }
                     </div>
                 ) : (
                   <p className='text-red-600 text-xs'>*Please upload product image</p>
                 )
               }
               
           </div>

           <label htmlFor='sellingPrice' className='mt-3'>Selling Price :</label>
           <input 
             type='number' 
             id='sellingPrice' 
             placeholder='enter selling price' 
             value={data.sellingPrice} 
             name='sellingPrice'
             onChange={handleOnChange}
             className='p-2 bg-slate-100 border rounded'
             required
           />

<label htmlFor='measurement' className='mt-3'>Measurement Units :</label>
           <input 
             type='text' 
             id='measurement' 
             placeholder='enter measurement units, kg, li,mm' 
             value={data.measurement} 
             name='measurement'
             onChange={handleOnChange}
             className='p-2 bg-slate-100 border rounded'
             required
           />


<label htmlFor='size' className='mt-3'>Size per the Measurement:</label>
           <input 
             type='text' 
             id='size' 
             placeholder='enter size,6*4, 13, 45,1' 
             value={data.size} 
             name='size'
             onChange={handleOnChange}
             className='p-2 bg-slate-100 border rounded'
             required
           />




<label htmlFor='moq' className='mt-3'>Minimum Order Quantity :</label>
           <input 
             type='number' 
             id='moq' 
             placeholder='Minimum Order Qunaity in Numbers, 10, 37' 
             value={data.moq} 
             name='moq'
             onChange={handleOnChange}
             className='p-2 bg-slate-100 border rounded'
             required
           />


<label htmlFor='youtubelink' className='mt-3'>Youtube Link :</label>
           <input 
             type='text' 
             id='youtubelink' 
             placeholder='https://youtube.com/watch?whYhd4yd' 
             value={data.youtubelink} 
             name='youtubelink'
             onChange={handleOnChange}
             className='p-2 bg-slate-100 border rounded'
           />


<label htmlFor='shipping' className='mt-3'>Shipping Fee :</label>
           <input 
             type='number' 
             id='shipping' 
             placeholder='enter shipping price' 
             value={data.shipping} 
             name='shipping'
             onChange={handleOnChange}
             className='p-2 bg-slate-100 border rounded'
             required
           />




<label htmlFor='color' className='mt-3'>Color(s) :</label>
           <input 
             type='text' 
             id='color' 
             placeholder='red, green, brown' 
             value={data.color} 
             name='color'
             onChange={handleOnChange}
             className='p-2 bg-slate-100 border rounded'
             required
           />



           <label htmlFor='description' className='mt-3'>Description :</label>
           <textarea 
             className='h-28 bg-slate-100 border resize-none p-1' 
             placeholder='enter product description' 
             rows={3} 
             onChange={handleOnChange} 
             name='description'
             value={data.description}
           >
           </textarea>





           <button className='px-3 py-2 bg-red-600 text-white mb-10 hover:bg-red-700'>Update Product</button>
       </form> 



   
    </div>



    {/***display image full screen */}
    {
     openFullScreenImage && (
       <DisplayImage onClose={()=>setOpenFullScreenImage(false)} imgUrl={fullScreenImage}/>
     )
    }
     

 </div>
  )
}

export default AdminEditProduct